import { render, staticRenderFns } from "./Optin.vue?vue&type=template&id=1ea6195e&scoped=true"
import script from "./Optin.vue?vue&type=script&lang=js"
export * from "./Optin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea6195e",
  null
  
)

export default component.exports